import { Controller } from "@hotwired/stimulus"

// Handles dynamic nested forms
export default class extends Controller {
  static targets = ["template", "target"]
  static values = {
    wrapperSelector: String
  }

  connect() {
    // Initialize any existing forms
    this.wrapperSelector = this.wrapperSelectorValue || '.nested-form-wrapper'
  }

  add(event) {
    event.preventDefault()
    
    // Get template content
    const content = this.templateTarget.innerHTML
    const newContent = content.replace(/NEW_RECORD/g, new Date().getTime())
    
    // Add new form
    this.targetTarget.insertAdjacentHTML('beforeend', newContent)
  }

  remove(event) {
    event.preventDefault()
    
    const wrapper = event.target.closest(this.wrapperSelector)
    
    // If it's a new record, remove it from the DOM
    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      // Otherwise, hide it and mark it for deletion
      wrapper.style.display = 'none'
      const destroyField = wrapper.querySelector('input[name*="_destroy"]')
      if (destroyField) {
        destroyField.value = '1'
      }
    }
  }
}
